import React, { createContext, useContext, useState } from 'react'

export interface PageContextProps {
  activeGlobalBanner?: string
  globalSettings?: any
  headerStyle?: 'Default' | 'Logo Only' | 'Logo & Login'
  heroFullWidthNarrow?: boolean
  isRegionBannerActive?: boolean
  isLP?: boolean
  localizedEntries?: any[]
  microCopyData?: any[]
  packageName?: string
  region?: 'US' | 'UK' | 'CA' | 'IE'
  regions?: any
  language?: string
  setActiveGlobalBanner?: (activeBanner: string) => void
  setIsRegionBannerActive?: (isActive: boolean) => void
  slug?: string
  styleContext?: string
  title?: string
  url?: string
  footerContent?: any
  disclaimers?: any[]
  salesIndicatorSchedule?: any
  siteMetadata?: any
  breadcrumbs?: any[]
  allEntries?: any[]
}

export const PageContext = createContext<PageContextProps | undefined>(
  undefined
)

export const PageContextProvider = ({
  value,
  children
}: {
  value?: PageContextProps
  children: any
}) => {
  const [activeGlobalBanner, setActiveGlobalBanner] = useState(null)
  const [isRegionBannerActive, setIsRegionBannerActive] = useState(false)

  return (
    <PageContext.Provider
      value={{
        ...value,
        activeGlobalBanner,
        isRegionBannerActive,
        setActiveGlobalBanner,
        setIsRegionBannerActive
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

export const usePageContext = () => {
  const context = useContext(PageContext)
  // Throw error if context is undefined, but allow this to run if in a Jest test environment
  // Todo - remove this Jest check and add context to the offending tests
  if (!context) {
    if (
      typeof process !== 'undefined' &&
      process.env.JEST_WORKER_ID !== undefined
    ) {
      return {}
    } else {
      throw new Error('usePageContext must be used within a PageContext')
    }
  }
  return context
}
